import { gql } from '@apollo/client';

export const SEARCH_MATERIALS = gql`
  query SearchMaterials($input: SearchMaterialsInput!) {
    searchMaterials(input: $input) {
      id
      name
      isReusable
      isStandardised
      unitsOfMeasurement {
        id
        name
        abbr
        isDefault
        categoryId
      }
    }
  }
`;
